import { __decorate, __extends } from "tslib";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Radar, mixins } from "vue-chartjs";
var ChartRadarComponent = /** @class */ (function (_super) {
    __extends(ChartRadarComponent, _super);
    function ChartRadarComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChartRadarComponent.prototype.mounted = function () {
        if (this.chartData) {
            this.renderChart(this.chartData, this.options);
        }
    };
    ChartRadarComponent.prototype.onChangeData = function (val, old) {
        if (this.chartData) {
            this.renderChart(this.chartData, this.options);
        }
    };
    __decorate([
        Prop({ type: Object, required: true })
    ], ChartRadarComponent.prototype, "chartData", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], ChartRadarComponent.prototype, "options", void 0);
    __decorate([
        Watch("chartData")
    ], ChartRadarComponent.prototype, "onChangeData", null);
    ChartRadarComponent = __decorate([
        Component({})
    ], ChartRadarComponent);
    return ChartRadarComponent;
}(Mixins(Radar, mixins.reactiveProp)));
export default ChartRadarComponent;
